import { motion, useReducedMotion } from "framer-motion";
import { engagementRoles, shippedProof, principles } from "@/data/team";

const TrustStrip = () => {
  const reduced = useReducedMotion();
  return (
    <section id="team" className="bg-background py-16 md:py-24">
      <div className="container mx-auto">
        <div className="max-w-4xl">
          <p className="eyebrow">How we staff your engagement</p>
          <h2 className="mt-4">One senior team, built for the technical fit your problem needs.</h2>
          <p className="lede mt-5">Every Skandor engagement is staffed by senior practitioners who have shipped enterprise-grade products. No juniors, no handoffs between a strategy team and a delivery team. You meet the people who will do the work on the diagnostic call, and they stay through handover.</p>
        </div>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 min-[1000px]:grid-cols-5">
          {engagementRoles.map(([key, role, body], i) => (
            <motion.article key={role} initial={reduced ? false : { opacity: .1, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: .12 }} transition={{ duration: .58, delay: i * .07, ease: [.2, .7, .2, 1] }} className={`surface-card p-5 ${i === 0 ? "surface-card-accent" : ""}`}>
              <p className="font-mono text-[.66rem] text-steel-2">{key}</p>
              <h3 className="mt-3">{role}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-2">{body}</p>
            </motion.article>
          ))}
        </div>
        <article className="surface-card mt-6 grid gap-8 p-5 min-[800px]:grid-cols-2 min-[800px]:gap-10 md:p-7">
          <div>
            <h3 className="font-mono text-[.66rem] tracking-wide text-steel-2">WHERE OUR PEOPLE HAVE SHIPPED</h3>
            <ul className="mt-4 space-y-3">
              {shippedProof.map((item) => (
                <li key={item} className="flex gap-3 text-sm leading-relaxed text-ink-2">
                  <span aria-hidden className="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-teal" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="min-[800px]:border-l min-[800px]:border-line min-[800px]:pl-10">
            <h3 className="font-mono text-[.66rem] tracking-wide text-steel-2">WHAT EVERY CLIENT CAN HOLD US TO</h3>
            <ul className="mt-4 space-y-3">
              {principles.map(([lead, body]) => (
                <li key={lead} className="text-sm leading-relaxed text-ink-2">
                  <strong className="font-semibold text-ink">{lead}</strong> {body}
                </li>
              ))}
            </ul>
          </div>
        </article>
      </div>
    </section>
  );
};
export default TrustStrip;
